import { Component, OnInit, Input, OnDestroy, Injector, NgZone, ViewChild, ViewContainerRef } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Data } from '../DataService';
import { RoutingService } from '../routing-service';
import { componentRoutes } from '../route-mapping';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { Subject } from 'rxjs';
import { ServiceStock } from '../service-stock.service';

@Component({
  selector: 'app-popup-modal',
  templateUrl: './popup-modal.component.html',
  styleUrls: ['./popup-modal.component.css']
})
export class PopupModalComponent implements OnInit {

  name: string;
  closeReq: boolean = true;

   @ViewChild("popupRouterOutlet", { read: RouterOutlet }) private popupRouterOutlet: RouterOutlet;

  constructor(public activeModal: NgbActiveModal, public services: ServiceStock) {
    //    console.log(this.router.config);
    //  this.routing.createNewOutlet();
    // this.name = this.routing.currOutlet;
    this.createNewOutlet();
    this.name = this.services.routing.currOutlet;

    // let outletJson = {};
    // outletJson[this.routing.currOutlet] = ['BLANK', 'popup'];
    // this.router.navigate([{ outlets: outletJson }], { skipLocationChange: true });
  }


  ngOnInit() {
    
  }

  viewInitialized: Subject<void> = new Subject<void>();

  ngAfterViewInit(){
    this.viewInitialized.next();
    this.viewInitialized.complete();
  }

  async rotueToComponent(map: Map<string, string>) {

    if (map) {
      await this.viewInitialized.toPromise();
      
      if(this.popupRouterOutlet.isActivated){
        this.popupRouterOutlet.deactivate();
      }

      let URL = map.get('component');
      map.delete("component");
      // this.dataStore.setData(this.routing.currModal, map);
      this.services.dataStore.setRouteParams(this.services.routing.currModal, map);
      let mode = undefined;
      //this.router.navigate([{ outlets: { 'test': [URL] } }], { skipLocationChange: true });
      if (URL) {
        if (map.has('mode')) {
          mode = map.get('mode');
        }
        let res = await this.services.routing.navigateToComponent(URL, mode);
        if (res && URL != 'message') {
          this.services.dataStore.setData(this.services.routing.currModal, res);
          this.closeReq = false;
          this.services.routing.navigateToComponent('message');
        }
      }
    }
  }

  createNewOutlet(){
    let newOutlet = this.services.routing.setnewOutlet();
  }

  async closeModal(): Promise<any>{
    // await this.destroyOutlet();
    await this.services.routing.removeOutlet();
    this.activeModal.close();
    return 'Closed';
  }

  // async destroyOutlet() {
  //   let outletJson = {};
  //   outletJson[this.services.routing.currOutlet] = null;
  //   await this.services.router.navigate([{ outlets: outletJson }]);
  //   this.services.routing.removeOutlet();
  // }

}
